import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Modal from "../UI/Modal";
import Button from "../UI/Button";
import classes from "./ReturningWelcomeWatcher.module.css";

const ReturningWelcomeWatcher = () => {
  const guest1Returning = useSelector((s) => s.booking.guest1Returning);
  const guest1Email = useSelector((s) => s.booking.guest1ReturningEmail);

  const guest2Returning = useSelector((s) => s.booking.guest2Returning);
  const guest2Email = useSelector((s) => s.booking.guest2ReturningEmail);

  const [queue, setQueue] = useState([]);

  const prev1 = useRef({ returning: undefined, email: undefined });
  const prev2 = useRef({ returning: undefined, email: undefined });

  useEffect(() => {
    const additions = [];

    const g1Changed =
      guest1Returning !== prev1.current.returning ||
      guest1Email !== prev1.current.email;

    if (g1Changed) {
      if (guest1Returning && guest1Email) {
        additions.push({ email: guest1Email, guestNumber: 1 });
      }
      prev1.current = { returning: guest1Returning, email: guest1Email };
    }

    const g2Changed =
      guest2Returning !== prev2.current.returning ||
      guest2Email !== prev2.current.email;

    if (g2Changed) {
      if (guest2Returning && guest2Email) {
        additions.push({ email: guest2Email, guestNumber: 2 });
      }
      prev2.current = { returning: guest2Returning, email: guest2Email };
    }

    if (additions.length) {
      additions.sort((a, b) => a.guestNumber - b.guestNumber);
      setQueue((q) => [...q, ...additions]);
    }
  }, [guest1Returning, guest1Email, guest2Returning, guest2Email]);

  const close = () => setQueue((q) => q.slice(1));
  const current = queue[0];

  return current ? (
    <Modal onClose={close}>
      <div className={classes.formContainer}>
        <h2>Welcome Back!</h2>

        <p className={classes.importantInformation}>
          We are so happy you have chosen to return to Amity Wellness.
        </p>

        <p className={classes.importantInformation}>
          Recognized email: <br />
          <strong>{current.email}</strong>
          {current.guestNumber ? ` (Guest ${current.guestNumber})` : ""}
        </p>

        <p className={classes.importantInformation}>
          Your loyalty discount has been applied automatically ✨
        </p>

        <div className={classes.buttonContainerSubmit}>
          <Button onClick={close} buttonText="Close" />
        </div>
      </div>
    </Modal>
  ) : null;
};

export default ReturningWelcomeWatcher;
